import { Card, CardActionArea, CardContent, CardHeader, Grid, Skeleton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { ContractDto } from '../../../services/dtos/contract.dto';
import Service from '../../others/service/service';
import logo_new_contrat from '../../../assets/images/mes-contrats.png';
import { Link } from 'react-router-dom';
import LinkOffIcon from '@mui/icons-material/LinkOff';

/**
 * Composant pour la page de la liste des contrats.
 * @constructor
 */
export default function ListContractsUi(props: {
    contracts?: Array<ContractDto>;
    loading: boolean;
    handleDettachContract: any;
}) {
    //On boucle dans les contrats pour les mettre dans la grille selon le chargement du loading
    let listContracts = props.contracts?.map(contract => (
        <Grid key={contract.contrat} item xs={12} md={6}>
            <Card sx={{ width: '100%' }}>
                {/*Titre + action de la card*/}
                {/*Action: détacher un contrat*/}
                <CardHeader
                    component={Link}
                    to={`/contrat/${contract['@id']}`}
                    title={`Contrat ${contract.informations?.abonne?.pdiReference}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                    action={
                        <Tooltip title="Détacher mon contrat" arrow>
                            <LinkOffIcon
                                color="error"
                                aria-label="Détacher mon contrat"
                                style={{ cursor: 'pointer' }}
                                onClick={event => {
                                    event.preventDefault();
                                    props.handleDettachContract(contract['@id']);
                                }}
                                data-testid={'detachedContract' + contract.contrat}
                            />
                        </Tooltip>
                    }
                ></CardHeader>
                {/*Informations du contrat*/}
                {/*Possiblité de clic qui envoi sur le détail du contrat*/}
                <CardActionArea component={Link} to={`/contrat/${contract['@id']}`}>
                    <CardContent>
                        {/* Affichage des infos du contrat */}
                        <Typography variant="body1" color="text.primary">
                            {contract.informations?.abonne?.titre} {contract.informations?.abonne?.nom}{' '}
                            {contract.informations?.abonne?.prenom}
                        </Typography>
                        <Typography variant="body1" color="text.primary">
                            {contract.informations?.abonne?.adresse}
                        </Typography>
                        <Typography variant="body1" color="text.primary">
                            Nature du contrat : {contract.informations?.abonne?.typeContrat}
                        </Typography>
                        <Typography variant="body1" color="text.primary">
                            Numéro du compteur : {contract.informations?.abonne?.numeroCompteur}
                        </Typography>
                        {contract.adresseCompteur && (
                            <Typography variant="body1" color="text.primary">
                                Lieu de consommation :{' '}
                                {contract.adresseCompteur?.adresse_complete ||
                                    `${contract.adresseCompteur?.numero || ''} ${
                                        contract.adresseCompteur?.rue || ''
                                    }, ${contract.adresseCompteur?.code_postal || ''} ${
                                        contract.adresseCompteur?.ville || ''
                                    }`.trim()}
                            </Typography>
                        )}
                        <Typography
                            variant="body2"
                            color="primary"
                            sx={{
                                marginTop: 2,
                                fontWeight: 'bold',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            }}
                        >
                            Accéder aux détails de mon contrat
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    ));

    //On ajoute le skeleton, les contrats seront ajoutés dans un nouveau container Grid
    let affichageContracts = props.loading ? (
        <Skeleton variant="rectangular" />
    ) : (
        <Grid className="containerHome" container spacing={6}>
            {listContracts}
        </Grid>
    );

    // Création de la page avec gestion du chargement
    return (
        <Grid className="containerHome" container spacing={6}>
            <Grid item xs={12}>
                <Typography variant="h4"> Mes contrats</Typography>
                <Typography variant="body1" color="text.primary">
                    Vous trouverez ci-dessous le ou les contrats liés à votre compte. Merci de cliquer sur le contrat
                    correspondant à votre démarche pour accéder à la page suivante.
                </Typography>
            </Grid>
            <Grid item xs={12}>
                {/*Affichage des contrats*/}
                {affichageContracts}
            </Grid>
            <Grid className="gridCard" item xs={12}>
                {/*Permet d'ajouter un contrat*/}
                <Service
                    title="Ajouter un contrat"
                    href="/rattacher-un-contrat"
                    img={logo_new_contrat}
                    styleName={'home-services'}
                />
            </Grid>
        </Grid>
    );
}
